const NO_VALUE = "N/A";
export const isSubscriptionProduct = (product) => {
    const { subscription = 0 } = product;
    if (!subscription) {
        return false;
    }
    return subscription === 1;
};
export const isCartonProduct = (product) => {
    const { subscription_format } = product;
    if (!subscription_format) {
        return false;
    }
    return ["carton", "mixed"].includes(subscription_format);
};
const buildCommerceItemsArray = (arrayWithCartItems) => {
    if (!arrayWithCartItems?.length) {
        return [];
    }
    return arrayWithCartItems.reduce((acc, item, index) => {
        if (!item) {
            return acc;
        }
        const { price, name, sku, quantity } = item;
        const discount = item.price_range?.maximum_price?.discount?.percent_off;
        let itemPrice = price;
        if ("productSalePrice" in item && item.productSalePrice !== undefined && item.productSalePrice !== null) {
            itemPrice = item.productSalePrice;
        }
        const isSubscriptionItem = isSubscriptionProduct(item);
        const isCartonItem = isCartonProduct(item);
        const data = {
            index: String(index),
            currency: price.currency,
            item_category: item.categories ? item.categories[0]?.name : NO_VALUE,
            item_category2: item.categories ? item.categories[1]?.name : NO_VALUE,
            item_color: item.color_label?.toLowerCase() ?? NO_VALUE,
            item_flavor: String(item.flavor ?? NO_VALUE),
            item_name: name,
            item_sku: sku,
            item_list_name: item.categories ? `${item.categories[0]?.name} > ${item.categories[1]?.name}` : NO_VALUE,
            item_list_id: item.categories ? `${item.categories[0]?.name} > ${item.categories[1]?.name}` : NO_VALUE,
            price: itemPrice.value,
            quantity: String(quantity),
            discount: `${discount ?? 0}%`,
            /*
              We need to ensure consistent item_id value throughout checkout process for tracking pursposes
              the best candidate to preserve consistency in this case seems to be SKU code
              https://jira.jtiweb.co.uk/browse/DESP-91609
            */
            item_id: sku || name,
            item_brand: "ploom",
            item_coupon: NO_VALUE,
            item_coupon_type: NO_VALUE,
            item_strength: NO_VALUE,
            item_rewards: NO_VALUE,
            purchase_type: isSubscriptionItem ? "subscription" : "one-time",
            carton_format: item?.subscription_format ?? NO_VALUE,
            carton_quantity: String(isCartonItem ? quantity : NO_VALUE),
        };
        acc.push(data);
        return acc;
    }, []);
};
export const buildCommerceBaseData = (trackingData, changedItemValue) => {
    let prices;
    if (trackingData.prices && "data" in trackingData.prices) {
        prices = trackingData.prices.data;
    }
    else {
        prices = trackingData.prices;
    }
    const value = changedItemValue
        ? changedItemValue
        : prices && ("total" in prices ? prices.total : prices.grandTotal.value);
    return {
        currency: "currency" in trackingData ? trackingData.currency.code : trackingData.prices?.grandTotal.currency || "N/A",
        value: Number(value),
        ecommerce: {
            items: buildCommerceItemsArray(trackingData.items),
        },
    };
};
//# sourceMappingURL=trackingHelpers.js.map